import React from "react";
import classNames from "classnames";

export function Button({children, customText, capsule, border, customBorder, onClick, link, addedClasses, loading, hide}) {

    const classes = classNames("btn text-decoration-none px-3",
        {
            'text-dark': !customText,
            'rounded-5': capsule,
            'border'   : border,
            'disabled': loading,
            'd-none': hide
        }
    , addedClasses);

    const style = {
        color:customText,
        borderColor:customBorder
    }

    if(loading) {

        return (
        <button className={classes} disabled>
            <span className="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
            <span  role="status">{children}</span>
        </button>
        );
    }

    if(link) {

        return (

            <a href={link} className={classes} style={style}>
                {children}
            </a>

        );

    } else {
        return (

            <button onClick={() => onClick()} className={classes} style={style}>
                {children}
            </button>

        );
    }


}